import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PageNotFound from './actualPages/PageNotFound.js'
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Blog from './actualPages/Blog.js';
import Blogs from './actualPages/Blogs.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/blog" element={ <Blogs/> } />
        <Route path="/blog/:storyShortName" action={({ params }) => {}} element={ <Blog /> } />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
